export interface IStorageValue {
    hasValue: boolean;
    value: string | null;
}

export function TryGetValue(key: string): IStorageValue {
    try {
        const storageValue = localStorage.getItem(key);
        if (storageValue) {
            return {
                hasValue: true,
                value: storageValue
            };
        } else {
            return {
                hasValue: false,
                value: null
            };
        }
    } catch (e) {
        console.error(e);
        return {
            hasValue: false,
            value: null
        };
    }
}

export function TrySetValue(key: string, value: string): boolean {
    try {
        localStorage.setItem(key, value);
        return true;
    } catch (e) {
        console.error(e);
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/App/shared/local-storage.tsx